export default {
    users: {
        manualCreate: {
            title: 'Create New Member Account',
            subtitleUserInformation: 'Member Information',
            subtitleCustomFields: 'Custom fields',
            successMessage: 'New Member has been added'
        },
        templateCreate: {
            title: 'Create New Template'
        },
        create: {
            title: 'Add New Member Account',
            defaultColumnsSubtitle: 'Default Columns',
            titleSubtitle: 'Title',
            typeSubtitle: 'Type',
            requiredSubtitle: 'Required',
            successMessage: 'New Member has been added',
            info:
                'In addition to the default fields, you can add two additional custom fields to your Member List. Insert the title of each field and select whether it is a text or numeric field. If no additional custom fields are needed, click Download button to proceed.',
            defaultFields: [
                {
                    label: 'Full Name',
                    description: 'lorem ipsum dolor sit amet lorem done'
                },
                {
                    label: 'Email',
                    description: 'lorem ipsum dolor sit amet lorem done'
                },
                {
                    label: 'Phone',
                    description: 'lorem ipsum dolor sit amet lorem done'
                },
                {
                    label: 'Status',
                    description: 'lorem ipsum dolor sit amet lorem done'
                },
                {
                    label: 'City',
                    description: 'lorem ipsum dolor sit amet lorem done'
                },
                {
                    label: 'State',
                    description: 'lorem ipsum dolor sit amet lorem done'
                },
                {
                    label: 'Country',
                    description: 'lorem ipsum dolor sit amet lorem done'
                },
                {
                    label: 'Department',
                    description: 'lorem ipsum dolor sit amet lorem done'
                }
            ]
        },
        edit: {
            title: 'Edit Member Account',
            subtitle: 'Member Information',
            subtitleCustom: 'Custom fields',
            successMessage: 'Member Information Updated',
            settings: {
                title: 'Account Settings',
                deactivate: {
                    title: 'Deactivate Account',
                    description:
                        'When you deactivate their account, the Member information will be saved, but they will no longer be able to access the Chill App. Ready to jump back in? Click the toggle to reactivate their account.',
                    successMessageActivated: 'The account has been Activated',
                    successMessageDeactivated:
                        'The account has been Deactivated'
                },
                delete: {
                    title: 'Delete Account',
                    description:
                        'Click the button below to delete their account which will permanently remove the Member’s access to and information from the Chill App.',
                    button: 'Delete account',
                    successMessage: 'The account has been deleted'
                },
                change: {
                    title: 'Move User to btc Business',
                    description:
                        'Click the button below to change Business for User account.',
                    confirmButton: 'change',
                    declineButton: 'cancel',
                    successMessage: 'User moved to btc Business'
                },
                reset: {
                    title: 'Reset Password',
                    description:
                        'Click the button below, and a password reset link will be automatically sent to their email address. They’ll be back on the Chill App in no time.',
                    button: 'Reset password',
                    successMessage: 'The account has been reseted'
                }
            },
            confirmation: {
                delete: {
                    title: 'Delete Account',
                    description:
                        'Are you sure you want to permanently delete this Business account?'
                }
            }
        },
        list: {
            title: 'Members List',
            createButton: 'Create member list',
            createUserButton: 'Add new member',
            importButton: 'import members',
            exportButton: 'export members',
            exportButtonDescription:
                'Download the current member list. If new members need to be added to an existing list, you can download the current member list, add the new members, and import the new member list',
            importButtonDescription: 'Import new members and custom fields',
            createButtonDescription: 'Create new members and custom fields',
            createUserButtonDescription: 'Create new member',
            status: {
                active: 'Active',
                inactive: 'Inactive'
            },
            importError: 'Member`s data in the file isn`t correct'
        },
        tableHeadersChampion: [
            { text: 'Full Name', value: 'fullName' },
            { text: 'Email', value: 'email', sortable: false },
            { text: 'Phone', value: 'phone', sortable: false },
            {
                text: 'Status',
                value: 'status',
                sortable: false,
                filter: [
                    {
                        title: 'All',
                        value: null
                    },
                    {
                        title: 'Active',
                        value: 'corporate'
                    },
                    {
                        title: 'Incomplete',
                        value: 'incomplete'
                    },
                    {
                        title: 'Unregistered',
                        value: 'unregistered'
                    },
                    {
                        title: 'Deactivated',
                        value: 'deactivated'
                    }
                ]
            },
            { text: 'City', value: 'city', sortable: false, filter: 'cities' },
            {
                text: 'State',
                value: 'state',
                sortable: false,
                filter: 'states'
            },
            {
                text: 'Country',
                value: 'country',
                sortable: false,
                filter: 'countries'
            },
            {
                text: 'Department',
                value: 'department',
                sortable: false,
                filter: 'departments'
            }
        ],
        tableHeadersAdmin: [
            { text: 'Full Name', value: 'fullName' },
            { text: 'Email', value: 'email', sortable: false },
            {
                text: 'Businesses',
                value: 'businessName',
                sortable: false,
                filter: 'businessNames'
            },
            {
                text: 'Trial Period',
                value: 'createdAt',
                sortable: false
            },
            {
                text: 'Status',
                value: 'status',
                sortable: false,
                filter: [
                    {
                        title: 'All',
                        value: null
                    },
                    {
                        title: 'Expired',
                        value: 'expired'
                    },
                    {
                        title: 'Deactivated',
                        value: 'deactivated'
                    },
                    {
                        title: 'Trial',
                        value: 'trial'
                    },
                    {
                        title: 'Monthly',
                        value: 'monthly'
                    },
                    {
                        title: 'Annual',
                        value: 'annual'
                    },
                    {
                        title: 'Discontinued',
                        value: 'discontinued'
                    },
                    {
                        title: 'Gympass',
                        value: 'gympass'
                    },
                    {
                        title: 'Corporate',
                        value: 'corporate'
                    },
                    {
                        title: 'Incomplete',
                        value: 'incomplete'
                    },
                    {
                        title: 'Unregistered',
                        value: 'unregistered'
                    }
                ]
            },
            {
                text: 'Coupon',
                value: 'subscription',
                sortable: false
            },
            {
                text: 'Device',
                value: 'device',
                sortable: false
            }
        ],
        push: {
            title: 'Send Push Notification',
            titleField: 'Title',
            messageField: 'Message',
            sessionField: 'Session ID to open on tap (optional)',
            mindfulMomentField: 'Mindful moment ID to open on tap (optional)',
            targetHint:
                'Fill at most one — leave both empty to just open the app.',
            send: 'Send',
            cancel: 'Cancel',
            successMessage: 'Push notification sent',
            noDevicesError: 'This user has no registered devices'
        },
        setPassword: {
            title: 'Set Password',
            description:
                'Sets a new password for this user. This replaces any existing password and clears any pending reset link.',
            passwordField: 'Password',
            save: 'Set password',
            cancel: 'Cancel',
            successMessage: 'Password updated'
        },
        mobile: {
            sort: {
                fullName: 'Full Name'
            },
            filter: {
                status: {
                    name: 'Filter by Status',
                    filter: [
                        {
                            text: 'All',
                            value: null
                        },
                        {
                            text: 'Active',
                            value: true
                        },
                        {
                            text: 'Inactive',
                            value: false
                        }
                    ]
                },
                cities: {
                    name: 'Filter by City',
                    value: 'city'
                },
                countries: {
                    name: 'Filter by Country',
                    value: 'country'
                },
                departments: {
                    name: 'Filter by Department',
                    value: 'department'
                },
                states: {
                    name: 'Filter by State',
                    value: 'state'
                },
                businessNames: {
                    name: 'Filter by Business',
                    value: 'businessName'
                }
            }
        }
    }
};
